import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import { Form } from 'react-bootstrap'
import FaIcon from '../../../helpers/fa_icon'

@inject("store")
@observer
export default class Extra extends React.Component {
  static propTypes = {
    extra: PropTypes.object.isRequired,
    onClickExtra: PropTypes.func,
    showCheckboxes: PropTypes.bool
  }

  handleSelection = (id) => {
    const { store } = this.props
    store.toggleExtraSelection(id)
  }

  renderName() {
    const { extra, onClickExtra } = this.props

    if(onClickExtra) {
      return (
        <span
          onClick={() => onClickExtra({extra})}
          style={{...styles.active, ...styles.clickableExtra}}
        >{ extra.name }</span>
      )
    }
    else {
      return <span style={styles.active}>{ extra.name }</span>
    }
  }
  
  render() {
    const { extra, showCheckboxes } = this.props
    const { id, selected, name } = extra

    if(showCheckboxes) {
      return (
        <Form.Check
          type="checkbox"
          style={styles.checkbox}
          id={`extra-${id}`}
          >
          <Form.Check.Input
            onChange={() => this.handleSelection(id)}
            checked={selected}
          />
          <Form.Check.Label>
            { this.renderName() }
          </Form.Check.Label>
        </Form.Check>
      )
    }
    else {
      return (
        <div>
          { this.renderName() }
        </div>
      )
    }
  }
}

const styles = {
  checkbox: {
    marginTop: 0,
    marginBottom: 5
  },
  clickableExtra: {
    cursor: 'pointer',
    textDecoration: 'underline'
  },
  active: {},
}